import styled from 'styled-components'
import { Drawer } from '@mui/material'
import Modal from 'styled-react-modal'

// parent:

export const LeaderboardPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: ${(props) => (props?.isMobile ? `calc(100% - 40px)` : '100%')};
`

export const LeaderboardPrimaryHeader = styled.div`
  background: #393e53;
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  padding: 0 30px;
  z-index: 2;
  font-size: 16px;
  border-width: 0;
  position: sticky;
  top: ${(props) => (props?.isMobile ? '40px' : '0px')};
`

export const LeaderboardProfileImage = styled.img`
  width: 45px;
  height: 45px;
  flex-shrink: 0;
  border-radius: 9px;
`

export const LeaderboardSecondaryHeader = styled.div`
  background: #393e53;
  color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  height: 55px;
  gap: 5px;
  border-width: 0;
  overflow: auto;
  padding: 0 12px;
  position: sticky;
  z-index: 2;
  top: ${(props) => (props?.isMobile ? '95px' : '55px')};
  @media (min-width: 800px) {
    padding: 0 42px;
    gap: 22px;
  }
  @media (min-width: 1300px) {
    padding: 0 72px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const LeaderboardSecondaryHeaderItems = styled.div`
  height: 100%;
  background: ${(props) => (props?.isActive ? '#1e1f23' : '#4d536e')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #fff;
  flex-shrink: 0;
  font-family: Outfit;
  border-radius: 17px 17px 0px 0px;
  font-size: 15px;
  gap: 5px;
  font-weight: ${(props) => (props?.isActive ? '700' : '500')};
  width: 152px;
  @media (min-width: 800px) {
    width: 200px;
    font-size: 18px;
  }
  @media (min-width: 1300px) {
    width: 290px;
  }
`

export const LeaderboardBody = styled.div`
  width: 100%;
  flex-grow: 1;
  position: relative;
  top: ${(props) => (props?.isMobile ? '40px' : '0px')};
`

export const LeaderboardSectionIcon = styled.img`
  height: 20px;
  margin-right: 5px;
`

// leaderboard section styles:

export const LeaderboardSectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 20px 0;
  padding: 0;
  color: ${({ themeType }) =>
    themeType === 'dark' ? 'rgba(255,255,255,0.95)' : '#1a0a4e'};
  width: 100%;
  text-align: left;

  @media (min-width: 768px) {
    font-size: 26px;
    margin-bottom: 24px;
  }
`

export const LeaderboardSectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme, themeType }) =>
    themeType === 'dark'
      ? 'rgba(37, 38, 42, 0.85)'
      : 'rgba(227, 235, 255, 0.6)'};
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 1rem;
  margin-bottom: 1.5rem;
  align-items: center;
  box-shadow: ${({ themeType }) =>
    themeType === 'dark'
      ? '0 4px 24px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.04)'
      : '0 4px 24px rgba(32, 7, 105, 0.08), inset 0 1px 0 rgba(255,255,255,0.6)'};
  border: 1px solid
    ${({ themeType }) =>
      themeType === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(32, 7, 105, 0.12)'};
  overflow: hidden;
  padding: 0 12px 24px;

  @media (min-width: 600px) {
    border-radius: 1.25rem;
    margin-bottom: 2rem;
    padding: 0 24px 32px;
  }
`

// highlighted leaders

export const HighlightedLeadersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 800px) {
    width: 50%;
  }
`

export const ComparisonModeSelectionContainer = styled.div`
  background: ${(props) =>
    props.theme === 'dark'
      ? 'rgba(26, 27, 32, 0.7)'
      : 'rgba(200, 217, 255, 0.5)'};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid
    ${(props) =>
      props.theme === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(32, 7, 105, 0.1)'};
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  border-radius: 14px;
  flex-shrink: 0;
  padding: 10px;
  margin: 20px 0;
  height: auto;
  min-height: auto;

  @media (min-width: 600px) {
    justify-content: space-around;
    flex-wrap: nowrap;
    margin: 28px auto;
    padding: 12px;
  }
`

export const ComparisonModeSelectionItem = styled.div`
  background-color: ${(props) =>
    props?.selected
      ? props.theme === 'dark'
        ? 'rgba(95, 46, 199, 0.4)'
        : 'rgba(32, 7, 105, 0.15)'
      : 'transparent'};
  border: 1px solid
    ${(props) =>
      props?.selected
        ? props.theme === 'dark'
          ? 'rgba(95, 46, 199, 0.5)'
          : 'rgba(32, 7, 105, 0.25)'
        : 'transparent'};
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  cursor: pointer;
  color: ${(props) =>
    props?.selected
      ? props.theme === 'dark'
        ? '#e8dfff'
        : '#1a0a4e'
      : props.theme === 'dark'
        ? 'rgba(255,255,255,0.85)'
        : '#3d2d7a'};
  font-family: Outfit;
  font-style: normal;
  line-height: normal;
  font-weight: ${(props) => (props?.selected ? 700 : 500)};
  font-size: 13px;
  padding: 10px 16px;
  min-height: 44px;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background-color: ${(props) =>
      !props?.selected && (props.theme === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(32, 7, 105, 0.08)')};
  }

  @media (min-width: 600px) {
    padding: 10px 28px;
    font-size: 15px;
  }
  @media (min-width: 1300px) {
    padding: 12px 44px;
    font-size: 16px;
  }
`

export const LeaderPicturesContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  margin: 40px 0;
  min-height: 160px;

  @media (min-width: 600px) {
    margin: 55px 0;
  }
  @media (min-width: 1300px) {
    margin: 120px 0;
  }
`

export const LeaderboardPictureSilver = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2px;
  border: 2px solid #c0c0c0;
  border-radius: 50%;
  background: url(${(props) => props?.background}) no-repeat center center;
  background-size: cover;
  position: relative;
  top: 35px;
  left: 5px;
  @media (min-width: 600px) {
    width: 89px;
    height: 89px;
    top: 60px;
    left: 10px;
    border-width: 3px;
  }
  @media (min-width: 1300px) {
    width: 150px;
    height: 150px;
    top: 100px;
    left: 20px;
  }
`

export const LeaderboardPictureGold = styled.div`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2px;
  border: 2px solid #ebff00;
  background: url(${(props) => props?.background}) no-repeat center center;
  border-radius: 50%;
  background-size: cover;

  @media (min-width: 600px) {
    width: 119px;
    height: 119px;
    border-width: 3px;
  }
  @media (min-width: 1300px) {
    width: 200px;
    height: 200px;
  }
`

export const LeaderboardPictureBronze = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2px;
  border: 2px solid #cd7f32;
  border-radius: 50%;
  background: url(${(props) => props?.background}) no-repeat center center;
  background-size: cover;
  position: relative;
  top: 35px;
  right: 5px;

  @media (min-width: 600px) {
    width: 89px;
    height: 89px;
    top: 60px;
    right: 10px;
    border-width: 3px;
  }
  @media (min-width: 1300px) {
    width: 150px;
    height: 150px;
    top: 100px;
    right: 20px;
  }
`

export const RankNumberText = styled.div`
  position: relative;
  bottom: 45px;
  color: ${(props) => (props.theme === 'dark' ? '#fff' : '#1016AE')};
  font-size: 14px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  @media (min-width: 600px) {
    bottom: 60px;
    font-size: 17px;
  }
  @media (min-width: 1300px) {
    font-size: 30px;
    font-weight: 600;
    bottom: 90px;
  }
`

export const CrownPicture = styled.img`
  position: relative;
  bottom: 45px;
  width: 18px;
  height: 18px;

  @media (min-width: 600px) {
    bottom: 60px;
    width: 25px;
    height: 25px;
  }
  @media (min-width: 1300px) {
    bottom: 90px;
    width: 43px;
    height: 43px;
  }
`

export const LeadersCrownAlt = styled.div`
  width: 10px;
  height: 10px;
  position: relative;
  bottom: 45px;
  flex-shrink: 0;
  border-radius: 10px;
  filter: blur(2px);
  background: ${(props) => (props?.type === 'silver' ? '#D2D2D2' : '#C17200')};

  @media (min-width: 600px) {
    width: 12px;
    height: 12px;
    bottom: 60px;
    border-radius: 12px;
  }
  @media (min-width: 1300px) {
    width: 20px;
    height: 20px;
    bottom: 90px;
    border-radius: 20px;
  }
`

export const LeadersName = styled.div`
  color: ${(props) => (props.theme === 'dark' ? '#fff' : '#1016AE')};
  font-family: Outfit;
  font-style: normal;
  line-height: normal;
  position: relative;
  font-size: 10px;
  font-weight: 300;
  top: ${(props) => (props?.secondary ? '32px' : '42px')};

  @media (min-width: 600px) {
    font-size: 12px;
    top: ${(props) => (props?.secondary ? '50px' : '70px')};
  }
  @media (min-width: 1300px) {
    font-size: 18px;
    font-weight: 500;
    top: ${(props) => (props?.secondary ? '90px' : '120px')};
  }
`

export const ScoreNumbers = styled.div`
  color: #fff;
  position: relative;
  top: ${(props) => (props?.secondary ? '35px' : '48px')};
  border-radius: 20px;
  background: ${(props) =>
    props.theme === 'dark'
      ? 'rgba(95, 46, 199, 0.5)'
      : 'rgba(32, 7, 105, 0.35)'};
  backdrop-filter: blur(6px);
  border: 1px solid
    ${(props) =>
      props.theme === 'dark' ? 'rgba(95, 46, 199, 0.4)' : 'rgba(32, 7, 105, 0.2)'};
  font-family: Outfit;
  font-style: normal;
  line-height: normal;
  gap: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  font-weight: 500;
  font-size: 12px;

  @media (min-width: 600px) {
    top: ${(props) => (props?.secondary ? '55px' : '80px')};
    padding: 2px 16px;
    font-size: 16px;
    border-radius: 31px;
  }
  @media (min-width: 1300px) {
    font-weight: 700;
    font-size: 18px;
    padding: 6px 21px;
    top: ${(props) => (props?.secondary ? '95px' : '125px')};
  }
`

// userstrips

export const UserScoreStripsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 12px;
  font-family: Outfit;
  margin: 0 auto;

  @media (min-width: 600px) {
    padding: 40px 0;
    width: 90%;
  }
  @media (min-width: 800px) {
    padding: 50px 0;
  }
`

export const UserScoreStrip = styled.div`
  height: auto;
  min-height: 56px;
  flex-shrink: 0;
  background: ${({ isMe, heading, themeType, theme }) => {
    if (heading) {
      return themeType === 'dark'
        ? 'rgba(30, 31, 35, 0.8)'
        : 'rgba(227, 235, 255, 0.7)'
    }
    if (isMe) {
      return themeType === 'dark'
        ? 'rgba(83, 84, 90, 0.6)'
        : 'rgba(90, 116, 182, 0.25)'
    }
    return themeType === 'dark'
      ? 'rgba(55, 56, 61, 0.5)'
      : 'rgba(255, 255, 255, 0.7)'
  }};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid
    ${({ themeType }) =>
      themeType === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(32, 7, 105, 0.06)'};
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  align-items: center;
  color: ${({ isMe, heading, themeType, theme }) => {
    if (isMe) return '#fff'
    return theme?.[themeType]?.leaderBoardTextColor
  }};
  font-family: Outfit;
  line-height: normal;
  font-weight: 500;
  border-radius: 12px;
  margin: 0 auto;
  padding: 12px 14px;
  font-size: 12px;
  width: 100%;
  max-width: 100%;
  gap: 8px;
  transition: all 0.2s ease;

  @media (min-width: 600px) {
    grid-template-columns: 1.5fr 3fr 1.5fr;
    padding: 0 18px;
    font-size: 14px;
    width: 90%;
    height: 56px;
    min-height: 56px;
  }
`

export const PrimaryCriteriaLabel = styled.div`
  color: #fff !important;
`

export const CriteriaChangerButton = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  justify-content: center;
  font-family: Outfit;
  background: rgba(32, 7, 105, 0.25);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(32, 7, 105, 0.2);
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(32, 7, 105, 0.35);
  }
`

export const CriteriaChangeOption = styled.div`
  min-width: 165px;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  font-family: Outfit;
  padding: 8px 5px;
  border-radius: 7px;
  cursor: pointer;
  color: ${(props) => (props?.selected ? '#10CC00' : '#FFF')};
  font-weight: 500;
  font-size: 14px;
  &:hover {
    color: #10cc00;
  }
`

// for your stats section

export const YourStatsSectionContainer = styled.div`
  width: 100%;
  display: flex;
  border-radius: 1rem;
  margin-bottom: 2rem;
  flex-direction: column;
  background: ${({ theme, themeType }) => theme?.[themeType].widgetContainerBackground};
  padding: 16px 12px;
  gap: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid
    ${({ themeType }) =>
      themeType === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(32, 7, 105, 0.08)'};
  overflow: hidden;

  @media (min-width: 600px) {
    padding: 24px 20px;
    gap: 28px;
    border-radius: 1.25rem;
  }
  @media (min-width: 1150px) {
    padding: 36px 40px;
  }
  @media (min-width: 1500px) {
    padding: 48px 80px;
  }
`
// for boxes

export const YourStatsBoxesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;

  @media (min-width: 600px) {
    gap: 16px;
    justify-content: flex-start;
  }
  @media (min-width: 1150px) {
    flex-grow: 1;
  }
`

export const YourStatsBoxesContainerColumn = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;

  @media (min-width: 600px) {
    align-items: ${(props) => (props?.left ? 'flex-end' : 'flex-start')};
    width: auto;
    gap: 15px;
  }
`

export const YourStatsSmallBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(50% - 6px);
  min-width: 120px;
  height: 110px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  border-radius: 14px;
  padding: 12px 14px;
  position: relative;
  overflow: hidden;
  background: ${({ theme, themeType }) => theme?.[themeType]?.statTileBackground};
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  }

  @media (min-width: 600px) {
    width: 249px;
    min-width: unset;
    height: 199px;
    padding: 24px 28px;
    border-radius: 20px;
  }
  @media (min-width: 1500px) {
    width: 334px;
    height: 268px;
    padding: 32px 32px;
  }
`

export const YourStatsBigBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-width: 120px;
  height: 160px;
  flex-shrink: 0;
  border-radius: 14px;
  padding: 14px 16px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  background: ${({ theme, themeType }) => theme?.[themeType]?.statTileBackground};
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  }

  @media (min-width: 600px) {
    width: 249px;
    min-width: unset;
    height: 298px;
    padding: 24px 28px;
    border-radius: 20px;
  }
  @media (min-width: 1500px) {
    width: 334px;
    height: 400px;
    padding: 32px 32px;
  }
`

export const GreenEffect = styled.div`
  position: absolute;
  top: 20px;
  right: 30px;
  width: 73.678px;
  height: 73.678px;
  background: #76ff36;
  filter: blur(50.5px);
  @media (min-width: 800px) {
    width: 147px;
    height: 147px;
    filter: blur(103px);
  }
`

export const PurpleEffect = styled.div`
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 53.678px;
  height: 53.678px;
  background: #b336ff;
  filter: blur(50.5px);
  @media (min-width: 800px) {
    width: 108px;
    height: 108px;
    filter: blur(75.5px);
  }
`

export const OrangeEffect = styled.div`
  position: absolute;
  bottom: 30px;
  left: 20px;
  width: 73.678px;
  height: 73.678px;
  background: #ffac36;
  filter: blur(50.5px);
  @media (min-width: 800px) {
    width: 147px;
    height: 147px;
    filter: blur(103px);
  }
`

export const BlueEffect = styled.div`
  position: absolute;
  top: 20px;
  left: 35px;
  width: 53.678px;
  height: 53.678px;
  background: #36cfff;
  filter: blur(50.5px);
  @media (min-width: 800px) {
    width: 108px;
    height: 108px;
    filter: blur(75.5px);
  }
`

export const PinkEffect = styled.div`
  position: absolute;
  top: 25px;
  left: 25px;
  width: 53.678px;
  height: 53.678px;
  background: #ffc0cb;
  filter: blur(40.5px);
  @media (min-width: 800px) {
    width: 108px;
    height: 108px;
    filter: blur(75.5px);
  }
`

export const TextRowOne = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.statTileTextColorSubHeading || 'grey'};
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 17px;
  padding-right: 10px;
  @media (min-width: 600px) {
    font-size: 14px;
  }
  @media (min-width: 1500px) {
    font-size: 22px;
    font-weight: 400;
  }
`

export const TextRowLast = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.statTileTextColorHeading};
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  font-size: 28px;
  line-height: 1.1;

  @media (min-width: 600px) {
    font-size: 52px;
    line-height: 52px;
  }
  @media (min-width: 1500px) {
    font-size: 77px;
    line-height: 77px;
  }
`

export const IconImageStats = styled.img`
  width: 21.556px;
  height: 20.478px;
  flex-shrink: 0;
  @media (min-width: 600px) {
    width: 32.148px;
    height: 30.539px;
  }
  @media (min-width: 1500px) {
    width: 43.175px;
    height: 41.014px;
  }
`

// for tables

export const YourStatsTablesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 13px;
  @media (min-width: 800px) {
    flex-grow: 1;
    gap: 21px;
  }
`

export const YourStatsTableItemHeading = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.statHeadingColor};
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 1.4px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 10px;
  @media (min-width: 800px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 1.4px;
  }
  margin-bottom: 10px;
`

export const YourStatsTableItemContainer = styled.div`
  width: 100%;
  background: ${({ theme, themeType }) => theme?.[themeType]?.statCardBackground};
  flex-grow: 0;
  border-radius: 16px;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 800px) {
    padding: 26px 30px;
    gap: 18px;
    border-radius: 18px;
  }
`

export const DisplayFlexSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const YourStatsTableItemKey = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.statCardHeadingColor};
  font-family: Outfit;
  font-size: 14px;
  line-height: 17px;
  @media (min-width: 800px) {
    font-size: 18px;
  }
`

export const YourStatsTableItemValue = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.statCardDataColor};
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px;
  @media (min-width: 800px) {
    font-size: 19px;
  }
`

// for 'Your Badges' section

export const YourBadgesSectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  margin-bottom: 2rem;
  background: ${({ theme, themeType }) => theme?.[themeType]?.widgetContainerBackground};
  padding: 28px 0;
  gap: 29px;
`

export const AllEarnedRewardsContainer = styled.div`
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 25px;
  border-radius: 24px;
  background: ${({ theme, themeType }) => theme?.[themeType]?.leaderBoardStripBackground};
  margin: 0 auto;
  padding: 19px 27px;
  @media (min-width: 500px) {
    gap: 55px;
  }
  @media (min-width: 800px) {
    padding: 25px 50px;
    gap: 60px;
  }
  @media (min-width: 1500px) {
    padding: 30px 94px;
    gap: 75px;
  }
`

export const AwardCircleGeneric = styled.div`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  background: ${(props) => props?.colorString};
  width: 109px;
  height: 109px;
  margin-bottom: 13.79px;
  @media (min-width: 800px) {
    width: 129px;
    height: 129px;
    margin-bottom: 17px;
  }
  @media (min-width: 1500px) {
    width: 166px;
    height: 166px;
    margin-bottom: 21px;
  }
`

export const GlowyEffectOfCircle = styled.div`
  width: 95.134px;
  height: 95.134px;
  border-radius: 50%;
  flex-shrink: 0;
  position: absolute;
  bottom: -12px;
  background: ${(props) => props?.colorString};
  filter: blur(16.5px);
  @media (min-width: 800px) {
    width: 112px;
    height: 112px;
    bottom: -18px;
  }
  @media (min-width: 1500px) {
    width: 145.012px;
    height: 145.012px;
  }
`

export const DiscUnderCircle = styled.img`
  width: 121.91px;
  flex-shrink: 0;
  @media (min-width: 800px) {
    width: 155.825px;
  }
  @media (min-width: 1500px) {
    width: 185.825px;
  }
`

export const ActiveAwardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`

export const AwardTitleGeneric = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.badgeTitleColor};
  text-align: center;
  font-family: Outfit;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 1.05px;
  margin-bottom: 6px;
  max-width: 121.91px;
  ${(props) => props?.moreMargin && `margin-top: 8px`};
  @media (min-width: 800px) {
    max-width: 155px;
    ${(props) => props?.moreMargin && `margin-top: 12px`};
  }
  @media (min-width: 1500px) {
    font-size: 20px;
    line-height: 21px;
    max-width: 185px;
    ${(props) => props?.moreMargin && `margin-top: 20px`};
  }
`

export const AwardSubtitleGeneric = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.badgeSubtitleColor};
  text-align: center;
  font-family: Outfit;
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
  line-height: 17px;
  letter-spacing: 0.7px;
  margin-bottom: 8px;
  max-width: 121.91px;
  @media (min-width: 800px) {
    max-width: 155px;
  }
  @media (min-width: 1500px) {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.98px;
    margin-bottom: 12px;
    max-width: 185px;
  }
`

export const AwardsRow = styled.div`
  display: flex;
  gap: 30px;
  overflow: auto;
  padding: 0 25px;

  @media (min-width: 800px) {
    gap: 45px;
    padding: 0 35px;
  }
  @media (min-width: 1500px) {
    gap: 70px;
    padding: 0 55px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const EarnFirstRewardContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const EarnFirstRewardPictureHeading = styled.span`
  color: ${({ theme, themeType }) => theme?.[themeType]?.badgeTitleColor};
  text-align: center;
  cursor: default;
  font-family: Outfit;
  font-size: ${(props) => (props?.big ? '42px' : '18px')};
  font-style: normal;
  font-weight: ${(props) => (props?.big ? '700' : '400')};
  line-height: ${(props) => (props?.big ? '45px' : '24px')};
  ${(props) => props?.big && 'letter-spacing: 2.94px;'};
`

export const EarnFirstRewardPicture = styled.img`
  width: 146px;
  margin: 50px 0 27px 0;
`

export const EarnFirstRewardFooterHeading = styled.div`
  color: ${({ first, theme, themeType }) =>
    first ? theme?.[themeType]?.badgeSubtitleColor : '#FFF'};
  font-family: Outfit;
  font-style: normal;
  font-size: ${(props) => (props?.first ? '18px' : '12px')};
  font-weight: ${(props) => (props?.first ? '300' : '600')};
  margin-bottom: ${(props) => (!props?.first ? '15px' : '5px')};
  line-height: 17px;
  cursor: pointer;
  @media (min-width: 800px) {
    font-size: ${(props) => (props?.first ? '23px' : '16px')};
    line-height: 17px;
  }
`

export const ContextBoxForBadge = styled.div`
  position: absolute;
  min-width: 27.068px;
  height: 18.537px;
  flex-shrink: 0;
  cursor: default;
  border-radius: 4px;
  background: #fff;
  bottom: 10px;
  right: 0px;
  color: #53545f;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Outfit;
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  padding: 0 2px;
  @media (min-width: 800px) {
    min-width: 34.051px;
    font-size: 11px;
    height: 25.617px;
    font-weight: 600;
  }
  @media (min-width: 1500px) {
    min-width: 42.051px;
    font-size: 13px;
    height: 29.617px;
    font-weight: 600;
  }
`

// detail of badge

export const BadgeInformationDrawer = styled(Drawer)`
  display: flex;
  justify-content: center;
  // backdrop-filter: blur(1px);
  background-color: rgba(106, 109, 210, 0.2);
  .MuiPaper-root {
    height: 70vh;
    width: 100%;
    left: auto;
    right: auto;
    background: #ffffff;
    background-size: 100% 100%;
    border-radius: 25px 25px 0px 0px;
  }
`

export const BadgeDetailContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const AwardContainerBox = styled.div`
  width: 100%;
  height: 50%;
  background: ${(props) => props?.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const DetailContainerBox = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 41px;
  color: #ff839b;
  font-family: Outfit;
  font-style: normal;
  text-align: center;
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  cursor: default;
  @media (min-width: 800px) {
    font-size: 19px;
    line-height: 24px;
    padding: 44px;
  }
`

export const DetailCloseButton = styled.button`
  color: #44008e;
  text-align: center;
  flex-shrink: 0;
  flex-grow: 0;
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 2.1px;
  text-decoration: underline;
  padding: 8.7px 24px;
  border-radius: 35px;
  background: #ead7ff;
  max-width: 102px;
`

export const StyledBadgeInformationModal = Modal.styled`
  width: 300px;
  height: 459px; 
  opacity: ${(props) => props.opacity};
  transition : all 0.3s ease-in-out;
  border-radius: 25px;
  position: relative;
  overflow: hidden;
  background: #FFF;
  border-radius: 52px;
  @media(min-width: 1500px) {
    width: 350px;
    height: 530px; 
  }
`
